module.exports = __webpack_public_path__ + "img/download-hero.05c6e1f4.png";